module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5TRrO"))).then(() => parcelRequire('3a9aZ'));